import Footer from "./components/Footer";
import { AppContainer } from "./styled";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";
import './all.min.css';
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useContext, useEffect } from "react";
import LayoutDashboard from "./Layout/Dashboard";
import Swap from "./page/Swap";
import Pool from "./page/Staking";
import Presale from "./page/Presale";
import Launchpad from "./page/Launchpad";
import Farms from "./page/Farms";
import AddFarm from "./page/Farms";
import CreateFarm from "./page/Farms/CreatePool";
import FarmDetails from "./page/Farms/Details";
import LayoutFarm from "./Layout/Farms";
//import Pools from "./page/Pools";
//import AddPool from "./page/Pools";
//import CreatePool from "./page/Pools/CreatePool";
//import PoolDetails from "./page/Pools/Details";
//import LayoutPools from "./Layout/Pools";
import Liquidity from "./page/Liquidity";
import Community from "./page/Community";
import { store } from "./store/store";
import { Provider } from "react-redux";
import WebApp from "@twa-dev/sdk";
import IDODetail from "./page/Launchpad/Detail";
import AddLiquidity from "./page/Liquidity";
import CreatePoolLiquidity from "./page/Liquidity/CreatePool";
import LiquidityDetails from "./page/Liquidity/Details";
import LayoutLiquidity from "./Layout/Liquidity";
import Kibble from "./page/Kibble";
import { ContextProviderWrapper, GlobalStyle } from "@kibble-exchange/uikit";
import { REACT_APP_CONNECT_UI_PROVIDER } from "./constant"
import useStakingLoad from "hooks/staking/useStakingLoad";
import Farm from "page/Farm";
import Home from "page/Home";
const App = () => {
  const { pathname } = useLocation();
  const { theme, isMobile } = useContext(ContextProviderWrapper)!;

  useEffect(() => {
    if (pathname) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  useEffect(() => {
    WebApp.ready();
  }, []);

  return (
    <Provider store={store}>
      <TonConnectUIProvider manifestUrl={REACT_APP_CONNECT_UI_PROVIDER}>
        <Toaster
          position="top-right"
          reverseOrder={false}
          toastOptions={{
            style: {
              fontFamily: "Syne",
            },
          }}
        />
        <GlobalStyle theme={theme} />
        <ApplicationsInitializations />
        <AppContainer className={`${theme} ${pathname === '/kibble' && theme === "dark" ? 'is-kibble' : pathname === '/kibble' && theme === "light" ? `is-kibble ${theme}`  : ''}`} pathname={pathname === "/"}>
          <Routes>
            <Route element={<LayoutDashboard />}>
              <Route path="/" element={<Home />} /> {/* Add the new Home route */}
              <Route index path="presale" element={<Presale />} />
              <Route index path="swap" element={<Swap />} />
              <Route path="pools" element={<LayoutFarm />}>
                <Route index element={<Pool />} />
                <Route path="details/:id" element={<Farm />} />
              </Route>
              <Route path="launchpad" element={<Launchpad />} />
              <Route path="kibble" element={<Kibble />} />
              <Route path="launchpad/:id" element={<IDODetail />} />
              <Route path="liquidity" element={<LayoutLiquidity />}>
                <Route index element={<Liquidity />} />
                <Route path="provide" element={<AddLiquidity />} />
                <Route path="details/:id" element={<LiquidityDetails />} />
                <Route path="init" element={<CreatePoolLiquidity />} />
              </Route>
              <Route path="farms" element={<LayoutFarm />}>
                <Route index element={<Farms />} />
                <Route path="provide" element={<AddFarm />} />
                <Route path="details/:id" element={<FarmDetails />} />
                <Route path="init" element={<CreateFarm />} />
              </Route>
              <Route path="assets/*" />
              {/*<Route path="pools" element={<LayoutPools />}>
                <Route index element={<Pools />} />
                <Route path="provide" element={<AddPool />} />
                <Route path="details/:id" element={<PoolDetails />} />
                <Route path="init" element={<CreatePool />} />
              </Route>*/}
              <Route path="community-tool" element={<Community />} />
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
            {/* Redirect to home for all other routes */}
          </Routes>
          {!isMobile && <Footer />}
        </AppContainer>
      </TonConnectUIProvider>
    </Provider>
  );
};

function ApplicationsInitializations() {
  useStakingLoad()
  return null;
}
export default App;
